import React, { useEffect, useState } from 'react'
import Button from "reactstrap/es/Button"
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { message } from 'antd'
import { bulkUpdateTags } from '../../../services/api/apiNextBarcode'

function BulkReturn(props) {
    const { resetBulkAll, reloadItems, closeMenu, items = [], selectedItems = [] } = { ...props }
    const [isOpen, setIsOpen] = useState(false)
    const [listItems, setListItems] = useState([])
    const [itemsSuccess, setItemsSuccess] = useState([])
    const [itemsError, setItemsError] = useState([])
    const [loading, setLoading] = useState(false)

    const _getEligibleItems = () => {
        return listItems.filter(item => {
            const tags = item.tags || []
            return tags.includes('shipped_vhmc') && !tags.includes('returned')
        })
    }

    const _isItemDisable = (item) => {
        const itemTags = item.tags || []
        const hasShippedVhmc = itemTags.includes('shipped_vhmc')
        const hasReturned = itemTags.includes('returned')
        return !hasShippedVhmc || hasReturned
    }

    const listItemsDisable = listItems.filter(_isItemDisable)
    const disabledBtn = listItems.length > 0 && listItemsDisable.length === listItems.length

    const _genListItems = () => {
        const listItems = items.filter(item => selectedItems.includes(item._id))
        setListItems(listItems)
    }

    useEffect(() => {
        _genListItems()
    }, [items, selectedItems])

    const _handleToggleModal = () => {
        setIsOpen(!isOpen)
        if (isOpen) {
            setItemsSuccess([])
            setItemsError([])
            resetBulkAll()
            closeMenu()
            reloadItems()
        }
    }

    const handleReturn = async () => {
        setLoading(true)
        setItemsError([])
        setItemsSuccess([])

        const eligibleItems = listItems.filter(item => {
            const tags = item.tags || []
            return tags.includes('shipped_vhmc') && !tags.includes('returned')
        })

        if (eligibleItems.length === 0) {
            message.warning('Không có item nào phù hợp để return.')
            setLoading(false)
            return
        }

        let successCount = 0
        let errorCount = 0

        for (const item of eligibleItems) {
            try {
                const payload = {
                    barcode_numbers: [item.barcodeNumber],
                    tags: ['shipped_vhmc'],
                    action: 'pull'
                }
                await bulkUpdateTags(payload)

                const payload2 = {
                    barcode_numbers: [item.barcodeNumber],
                    tags: ['returned'],
                    action: 'push'
                }
                const res = await bulkUpdateTags(payload2)
                if (res.success) {
                    successCount++
                    setItemsSuccess(prev => [...prev, item._id])
                } else {
                    errorCount++
                    setItemsError(prev => [...prev, { _id: item._id, message: res.message || 'Unknown error' }])
                }
            } catch (error) {
                errorCount++
                setItemsError(prev => [...prev, { _id: item._id, message: error.message }])
            }
        }

        setLoading(false)

        if (successCount > 0) {
            message.success(`Return thành công ${successCount} item.`)
        }
        if (errorCount > 0) {
            message.error(`Return thất bại ${errorCount} item.`)
        }
    }

    const _showMessage = (_id) => {
        if (itemsError.find(itemErr => _id === itemErr._id)) {
            return <span className="d-sm-block text-danger">{itemsError.find(itemErr => _id === itemErr._id).message}</span>
        }
        if (itemsSuccess.includes(_id)) {
            return <span className="d-sm-block text-success">Return thành công!</span>
        }
        return <span className="d-sm-block">Waiting...</span>
    }

    return (
        <div>
            <Button color="link" onClick={() => setIsOpen(true)} className="mr-1" disabled={disabledBtn}>Return</Button>
            {isOpen && (
                <Modal isOpen={isOpen} toggle={_handleToggleModal} className="BulkReturn">
                    <ModalHeader>
                        Đánh dấu return cho đơn hàng (Return)
                    </ModalHeader>
                    <ModalBody>
                        <div className="listItems mb-3">
                            <h6>Danh sách mã đơn:</h6>
                            {listItems.length > 0 && listItems.map(item => {
                                const tags = item.tags || []
                                const isEligible = tags.includes('shipped_vhmc') && !tags.includes('returned')
                                return (
                                    <div key={item._id} className="ItemGenLabel d-sm-flex mb-2 pb-2">
                                        <div className="IconStatus mr-2">
                                            {itemsSuccess.includes(item._id) && <i className="icon-check text-success" />}
                                            {itemsError.find(itemErr => item._id === itemErr._id) && <i className="icon-cross text-danger" />}
                                        </div>
                                        <div className="ContentGenLabel">
                                            <strong>#{item.barcodeNumber}</strong> - {item.orderNumber}
                                            {!isEligible && <span className="text-warning ml-2">(Không phù hợp)</span>}
                                            {_showMessage(item._id)}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <div className="d-sm-flex">
                            <Button
                                disabled={loading}
                                onClick={_handleToggleModal}
                                className="bg-grey ml-2"
                            >
                                Đóng
                            </Button>
                            {!(itemsSuccess.length > 0 && itemsSuccess.length + itemsError.length === listItems.length) && (
                                <Button
                                    disabled={loading}
                                    onClick={handleReturn}
                                    className="bg-primary ml-2"
                                >
                                    Return {loading && <i className='icon-spinner2 spinner ml-2' />}
                                </Button>
                            )}
                        </div>
                    </ModalFooter>
                </Modal>
            )}
        </div>
    )
}

export default BulkReturn